<!-- Header -->
<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="ct-t-icon">
      <mat-icon>history</mat-icon>
    </div>
    <div>
      <div class="ct-t-name">
        {{ isProvider ? 'Histórico proveedor' : 'Histórico cliente' }}
      </div>
      <div class="ct-t-name-sub" *ngIf="ready && dataSource.length > 0">
        {{ isProvider ? dataSource[0].issuerName : dataSource[0].receiverName }}
      </div>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" [mat-dialog-close] aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Loading -->
<ng-container *ngIf="!ready">
  <div class="ct-t-splash">
    <div class="cf-contact-splash__icon-wrap">
      <mat-icon>history</mat-icon>
    </div>
    <div class="cf-contact-splash__dots">
      <span></span><span></span><span></span>
    </div>
    <p class="cf-contact-splash__text">Cargando facturas…</p>
  </div>
</ng-container>

<!-- Content -->
<mat-dialog-content class="ci-body" *ngIf="ready">

  <!-- Empty state -->
  <ng-container *ngIf="dataSource.length === 0">
    <div class="ci-empty">
      <mat-icon>inbox</mat-icon>
      <p>No hay facturas registradas.</p>
    </div>
  </ng-container>

  <!-- Table -->
  <ng-container *ngIf="dataSource.length > 0">

    <ng-container *ngIf="isClient">
      <app-table [columns]="headerTableC" [dataSource]="dataSource"
        [hasButton]="true" [hasHeaderActions]="false"
        [headerActionsTemplate]="emptyActions">
      </app-table>
    </ng-container>

    <ng-container *ngIf="isProvider">
      <app-table [columns]="headerTableP" [dataSource]="dataSource"
        [hasButton]="true" [hasHeaderActions]="false"
        [headerActionsTemplate]="emptyActions">
      </app-table>
    </ng-container>

    <ng-template #emptyActions></ng-template>

  </ng-container>

</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions align="end" class="ct-t-actions">
  <button mat-stroked-button (click)="printExcel()">
    <mat-icon>file_download</mat-icon>
    Excel
  </button>
  <button mat-stroked-button [mat-dialog-close]>Cerrar</button>
</mat-dialog-actions>
